// Treatment packages. `price` is in BDT per `unit` ("day" | "visit").
// Investigation/treatment prices are sample values — confirm with the client.
const packages = [
  {
    id: 1,
    slug: "basic-care-package",
    name: "Basic Care Package",
    tier: "Category 1",
    price: 4000,
    unit: "day",
    minStayDays: 15,
    featured: false,
    img: "/assets/images/team/1.jpg",
    description: "Suitable for patients requiring basic psychiatric or addiction care under professional supervision in a structured and supportive environment.",
    accommodation: "Shared non-AC / standard room with attached bathroom, basic furniture, personal cabinet, ceiling fan, clean bedding, and common recreational area.",
    includes: [
      "Room charges and regular meals",
      "Basic medical advice and supervision",
      "Nursing care and skilled attendant support",
      "Individual counseling sessions",
      "Group therapy sessions",
      "Light physical exercise",
      "Religious & motivational sessions",
      "Recreational activities",
    ],
    excludes: [
      "Diagnostic tests at actual",
      "Specialized doctor consultation at actual",
      "Medicines at actual",
      "Laundry & personal services",
      "Personal items and extra food",
      "Special family counseling sessions",
    ],
    terms: [
      "Minimum 15 days’ payment during admission",
      "Advance payment required for continuation",
      "All dues must be cleared before discharge",
    ],
    pricing: {
      investigations: [
        {
          name: "Initial Psychiatric Assessment",
          price: 1500,
        },
        {
          name: "Mental Status Examination",
          price: 1000,
        },
        {
          name: "Psychological Testing",
          price: 2500,
        },
        {
          name: "Follow-up Evaluation",
          price: 800,
        },
      ],
      treatments: [
        {
          name: "Medication Management (per review)",
          price: 1000,
        },
        {
          name: "Individual Psychotherapy (per session)",
          price: 2000,
        },
        {
          name: "Crisis Intervention",
          price: 3000,
        },
        {
          name: "Long-term Treatment Planning",
          price: 1500,
        },
      ],
    },
    order: 1,
  },
  {
    id: 2,
    slug: "standard-care-package",
    name: "Standard Care Package",
    tier: "Category 2",
    price: 7000,
    unit: "day",
    minStayDays: 15,
    featured: true,
    img: "/assets/images/team/2.jpg",
    description: "Designed for patients who require structured treatment, enhanced comfort, and comprehensive therapy for psychiatric or addiction recovery.",
    accommodation: "Twin sharing AC deluxe room with attached bath, geyser, refrigerator, flower pot, daily fruits basket, personal cabinet, gym & fitness studio access, unit box, smart TV, private balcony, and rooftop garden access.",
    includes: [
      "Room charges and nutritious meals",
      "Psychiatric consultation & basic medical advice",
      "24/7 nursing care & skilled supervision",
      "Individual counseling sessions",
      "Group therapy by addiction counselors & psychologists",
      "Yoga & meditation sessions",
      "Weekly NA meeting",
      "Outing and recreational programs",
      "Weekly support group programs",
      "Physical exercise & training by gym instructor",
      "Religious & spiritual lecture programs",
    ],
    excludes: [
      "All diagnostic tests at actual",
      "Specialized consultancy charges",
      "Property damage or breakage cost",
      "Escorting services if required",
      "Dope tests during admission & discharge",
      "Ambulance or special transport services",
      "Cost of medicines at actual",
      "Laundry, saloon & personal services",
      "Personal expenses (extra food, cigarettes, etc.)",
      "Special family counseling sessions",
    ],
    terms: [
      "Minimum 15 days’ payment required at admission",
      "Fortnightly advance payment from second week",
      "All dues must be cleared at discharge",
    ],
    pricing: {
      investigations: [
        {
          name: "Addiction Assessment",
          price: 2000,
        },
        {
          name: "Urine Toxicology Screening",
          price: 1800,
        },
        {
          name: "Psychiatric Evaluation",
          price: 1500,
        },
      ],
      treatments: [
        {
          name: "Detoxification Programme (per day)",
          price: 2500,
        },
        {
          name: "Family Counseling (per session)",
          price: 2000,
        },
        {
          name: "Outpatient Therapy (per session)",
          price: 1500,
        },
      ],
    },
    order: 2,
  },
  {
    id: 3,
    slug: "premium-recovery-package",
    name: "Premium Recovery Package",
    tier: "Category 3",
    price: 10000,
    unit: "day",
    minStayDays: 15,
    featured: false,
    img: "/assets/images/team/3.jpg",
    description: "A comprehensive and intensive recovery package offering maximum comfort, personalized care, and advanced therapeutic services for long-term treatment and rehabilitation.",
    accommodation: "Single occupancy AC premium room with attached bath, geyser, refrigerator, daily fruits & nutrition basket, personal wardrobe, smart TV, high-speed internet access, private sitting area, balcony, and rooftop garden access.",
    includes: [
      "Room charges and customized meal plan",
      "Daily psychiatrist supervision",
      "24/7 nursing and skilled attendant support",
      "Personalized treatment & recovery plan",
      "Individual therapy sessions",
      "Intensive group therapy programs",
      "Family counseling sessions",
      "Advanced relapse prevention planning",
      "Yoga, meditation & mindfulness therapy",
      "Gym, fitness & physical training",
      "Recreational, outing & wellness activities",
      "Religious & motivational sessions",
    ],
    excludes: [
      "Specialized investigations and diagnostics",
      "External consultant fees",
      "Emergency or special ambulance services",
      "Medicines and medical supplies",
      "Personal care services and extras",
    ],
    terms: [
      "Minimum 15 days’ advance payment required",
      "Payments to be made fortnightly in advance",
      "All dues must be settled before discharge",
    ],
    pricing: {
      investigations: [
        {
          name: "Comprehensive Psychological Assessment",
          price: 3500,
        },
        {
          name: "Personality Testing",
          price: 3000,
        },
      ],
      treatments: [
        {
          name: "Additional Individual Therapy Session",
          price: 2500,
        },
        {
          name: "Couples / Family Therapy Session",
          price: 3000,
        },
        {
          name: "Additional Group Therapy Session",
          price: 800,
        },
      ],
    },
    order: 3,
  },
  {
    id: 4,
    slug: "opd-mental-health-care",
    name: "OPD Mental Health Care",
    tier: "Outpatient",
    price: 2000,
    unit: "visit",
    minStayDays: 0,
    featured: false,
    img: "/assets/images/team/4.jpg",
    description: "Ideal for patients who require regular psychiatric consultation and counseling without residential admission.",
    accommodation: "No residential stay required (Outpatient service).",
    includes: [
      "Psychiatric consultation",
      "Psychological counseling session",
      "Medication review",
      "Follow-up guidance",
    ],
    excludes: [
      "Medicines at actual",
      "Diagnostic investigations",
      "Emergency services",
    ],
    terms: ["Payment required per visit", "Appointment-based service"],
    pricing: {
      investigations: [
        {
          name: "Initial Psychiatric Evaluation",
          price: 1500,
        },
        {
          name: "Psychological Screening",
          price: 1000,
        },
      ],
      treatments: [
        {
          name: "Follow-up Consultation",
          price: 1000,
        },
        {
          name: "Counseling Session",
          price: 1500,
        },
      ],
    },
    order: 4,
  },
];

export default packages;
